<template>
    <svg id="m_h" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 165.6 165.6">
        <path id="m_a" class="cls-1" d="M84,5.7A78.3,78.3,0,1,1,5.7,84,78.3,78.3,0,0,1,84,5.7"></path>
        <g id="m_g">
            <line id="a_1" class="cls-1" x1="82.64" y1="128.52" x2="82.64" y2="34.52" style="stroke-dasharray: none; stroke-dashoffset: 1e-05;"></line>
            <line id="a_2" class="cls-1" x1="79.8" y1="134.54" x2="128.65" y2="85.69" style="stroke-dasharray: none; stroke-dashoffset: 1e-05;"></line>
            <line id="a_3" class="cls-1" x1="85.8" y1="134.54" x2="36.94" y2="85.69" style="stroke-dasharray: none; stroke-dashoffset: 1e-05;"></line>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'NextIcon'
}
</script>

<style scoped>
    svg {
        width: 60px;
    }
    .cls-1 {
        fill: none;
        stroke: #fff;
        stroke-miterlimit: 10;
        stroke-width: 9px;
    }
</style>
